import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import FeesFilter from "./Fees";
import ClientTypesFilter from "./ClientTypes";
import SpecialtiesFilter from "./Specialties";
import TreatmentModalitiesFilter from "./TreatmentModalities";
import AvailabilityFilter from "./Availability";
import DemographicsFilter from "./Demographics";
import UserTypesFilter from "./UserTypes";
import MedicationPrescriberFilter from "./MedicationPrescriber";

import LocationFilter from "./Location";
import LicensedInFilter from "./LicensedIn";
import InsurancePlansFilter from "./InsurancePlans";
import CurrentStatusFilter from "./CurrentStatus";
import DegreesFilter from "./Degrees";
import CredentialsFilter from "./Credential";
import TrainingFilter from "./Training";
import ProviderFilter from "./Provider";
import LanguagesFilter from "./Languages";
import { ReactComponent as BackArrow } from "../../../assets/Icons/filter-back-arrow.svg";
import { ReactComponent as FilterIcon } from "../../../assets/Icons/filter-icon.svg";
import { treatment_program } from "../../../constants/common";
import ServicesAvilable from "./ServicesAvilable";
import SessionsOfferedFilter from "./SessionsOffered";
import { useAuth } from "../../../contexts/Auth";

const Filters = ({
  setFilters,
  filters,
  reset,
  isMobileView,
  closeFilters,
  setClearStatus,
  clearStatus,
}) => {
  const { account_type } = useAuth();
  const activeFiltersCount = Object.keys(filters ?? {}).filter((key) => {
    const value = filters[key];
    return (
      !["sortBy", "search", "page"].includes(key) &&
      value !== undefined &&
      value !== "" &&
      !(Array.isArray(value) && value.length === 0)
    );
  }).length;

  return (
    <Paper>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: isMobileView ? "100vw" : "100%",
          py: 1.5,
          px: 3,
        }}
      >
        {isMobileView ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Button
              sx={{
                p: 0,
                minWidth: 0,
                textDecoration: !isMobileView ? "none" : "underline",
                color: "#0C8CE9",
              }}
              onClick={closeFilters}
            >
              <BackArrow />
            </Button>
          </Box>
        ) : null}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <FilterIcon />
          <Typography variant="h5">
            Filter {Boolean(activeFiltersCount) && `(${activeFiltersCount})`}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Button
            sx={{
              p: 0,
              minWidth: 0,
              textDecoration: !isMobileView ? "none" : "underline",
              color: "#0C8CE9",
            }}
            onClick={reset}
          >
            {!isMobileView ? " Reset all" : "Clear all"}
          </Button>
        </Box>
      </Box>
      <ProviderFilter value={filters?.provider || ""} setFilters={setFilters} />
      <Divider />
      {(
        <>
          <Box
            sx={{
              px: 3,
              py: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "auto",
                px: 1,
                justifyContent: "space-between",
                backgroundColor: "##E2E8F0",
                border: "1px #E2E8F0 solid",
                borderRadius: "8px",
                padding: "2px 20px",
                minHeight: "56px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: 0,
                }}
              >
                <Typography variant="h6">
                  Open to  Networking
                </Typography>
              </Box>
              <Box
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    open_networking: filters?.open_networking ? 0 : 1,
                    page: 1,
                  }))
                }
                sx={{
                  width: 36,
                  height: 18,
                  backgroundColor: filters?.open_networking
                    ? "#FF8C00"
                    : "#E0E0E0",
                  borderRadius: "12px",
                  position: "relative",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  padding: "2px",
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    width: 17,
                    height: 17,
                    backgroundColor: "white",
                    borderRadius: "50%",
                    position: "absolute",
                    left: filters?.open_networking ? "19px" : "2px",
                    transition: "left 0.1s ease",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Divider />
        </>
      )}
      <LocationFilter setFilters={setFilters} filters={filters} />
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <LicensedInFilter setFilters={setFilters} filters={filters} />
        </>
      )}
      {filters?.provider === treatment_program && (
        <>
          <Divider />
          <ServicesAvilable setFilters={setFilters} filters={filters} />
        </>
      )}
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <UserTypesFilter
            value={filters?.user_types || []}
            setFilters={setFilters}
          />
        </>
      )}
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <MedicationPrescriberFilter
            value={filters?.has_medication_prescriber || ""}
            setFilters={setFilters}
            filters={filters}
          />
        </>
      )}
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <CurrentStatusFilter
            value={filters.accepting_clients || ""}
            setFilters={setFilters}
          />
        </>
      )}
      {/* Payment Options (Insurance Plans + Private Pay): Therapists tab only. */}
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <InsurancePlansFilter
            isMobileView={isMobileView}
            value={filters?.insurance || []}
            setFilters={setFilters}
            filters={filters}
          />
        </>
      )}
      {/* <Divider />
      <FeesFilter
        filters={filters}
        setFilters={setFilters}
        setClearStatus={setClearStatus}
        clearStatus={clearStatus}
      /> */}
      <Divider />
      <ClientTypesFilter filters={filters} setFilters={setFilters} />
      <Divider />
      <SpecialtiesFilter
        isMobileView={isMobileView}
        filters={filters}
        value={filters?.specialties || []}
        setFilters={setFilters}
      />
      <Divider />
      <TreatmentModalitiesFilter
        filters={filters}
        value={filters?.modalities || []}
        setFilters={setFilters}
        isMobileView={isMobileView}
      />
      <Divider />
      <SessionsOfferedFilter
        setFilters={setFilters}
        filters={filters}
        // goBack={goBack}
        reset={reset}
      />
      <Divider />
      <AvailabilityFilter filters={filters} setFilters={setFilters} />
      <Divider />
      <DemographicsFilter filters={filters} setFilters={setFilters} />
      {filters?.provider === "therapists" && (
        <>
          <Divider />
          <DegreesFilter
            filters={filters}
            setFilters={setFilters}
            isMobileView={isMobileView}
          />
          {/* <Divider />
          <CredentialsFilter
            filters={filters}
            setFilters={setFilters}
          /> */}
          {/* <Divider />
          <TrainingFilter
            filters={filters}
            setFilters={setFilters}
          /> */}
        </>
      )}
      <Divider />
      <LanguagesFilter filters={filters} setFilters={setFilters} />
    </Paper>
  );
};

export default Filters;
